export interface IEditUserTbl {
	userId: number;
	firstName?: string;
	lastName?: string;
	userName?: string;
	phoneNumber?: string;
	email?: string;
	isActive: boolean;
	isActiveStr?: string;
	isLockedOut: boolean;
	isLockedOutStr?: string;
	friendlyId?: string;
	address?: any;
	addressFull?: string;
	domicileId?: number;
	domicile?: string;
	activeStatus?: string;
	role?: string;
	isTeamLead?: string;
	name?: string;
	experienceLevel?: string;
	isW9Received?: string;
	isExemptionFormReceived?: string;
	isResponseTrained?: string;
	toursOfDuty: number;
	employeeType?: string;
	driversLicenseClass?: string;
	hasHazMat?: string;
	lastWebLogin?: string;
	lastWebLoginDt?: Date;
	lastMobileLogin?: string;
	lastMobileLoginDt?: Date;
	isUpdatedOffline: boolean;
	permissionId?: number;
	permission?: string;
	permissionProfile?: string;
	canDelete: boolean;
};

export class EditUserTbl implements IEditUserTbl {
	userId = 0;
	firstName = '';
	lastName = '';
	userName = '';
	phoneNumber = '';
	email = '';
	isActive = false;
	isActiveStr = '';
	isLockedOut = false;
	isLockedOutStr = '';
	friendlyId = '';
	address = '';
	addressFull = '';
	domicileId = 0;
	domicile = '';
	activeStatus = '';
	role = '';
	isTeamLead = '';
	name = '';
	experienceLevel = '';
	isW9Received = '';
	isExemptionFormReceived = '';
	isResponseTrained = '';
	toursOfDuty = 0;
	employeeType = '';
	driversLicenseClass = '';
	hasHazMat = '';
	lastWebLogin = '';
	lastWebLoginDt = new Date();
	lastMobileLogin = '';
	lastMobileLoginDt = new Date();
	isUpdatedOffline = false;
	permissionId = 0;
	permission = '';
	permissionProfile = '';
	canDelete = false;
};
